import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { PostAPI } from "../../../ApiServices/ApiServices";

const VerifyEmail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email 
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");

    const handleChange = (otp) => {
        setOtp(otp);
        setError(""); 
        console.log("Entered OTP:", otp);
    };

    const verifyOTP = () => {
        if (otp.length !== 4 ) { // Ensure 4-digit number
            setError("Please enter a valid 4-digit OTP.");
            return;
        }

        const data = { email, otp_number: otp.toString()  };

        console.log("Verifying OTP with data:", data); // Debugging log

        PostAPI({ url: "/verify_otp", data }, (response) => {
            console.log("OTP Verification Response:", response);
            if (response?.status === 1) {
                console.log("OTP verified successfully!");
                navigate('/newpassword', { state: { email } }); // Pass email to new password screen
            } else {
                setError(response?.message || "Invalid OTP. Please try again.");
            }
        });
    };

    return (
        <div className='login-form container'>
            <div className='right-content'>
                <h4 className='form-head color-txt'>Verify Email</h4>
                <p className='wel-content'>Please enter the Password reset code below <br /> that was sent to <span className='color-txt'>{email}</span> </p>

            </div>
            <div className='form-box'>
             <p >Enter Verification Code</p>
                <div style={{ display:"flex",justifyContent: "center" }}>
                    <OTPInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={4} // Number of OTP fields
                        separator={<span style={{ margin: "0 8px" }}>-</span>} // Optional separator
                        renderInput={(props) => <input {...props} />}
                        inputStyle={{
                            width: "40px",
                            height: "40px",
                            margin: "10px 5px",
                            fontSize: "18px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            justifyContent: 'center'
                        }}
                        focusStyle={{
                            border: "1px solid #007BFF",
                            outline: "none",
                        }}
                    />
                </div>
                {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
                <Button variant="primary" onClick={verifyOTP} className='mt-3'>
                    Verify
                </Button>

            </div>

        </div>
    )
}

export default VerifyEmail